import { createTheme } from "@dash/default-theme";
import { SiteContainer } from "@dash/nav";
import { Theme, ThemeProvider } from "@emotion/react";
import {
  ACCOUNTS_URL,
  API_URL,
  CRM_URL,
  DOCS_URL,
  INVOICES_URL,
  POINTS_URL,
  QR_SYNC_URL,
  useConfig,
} from "@megarax/dev-config";
import { DocsPage } from "@megarax/dev-docs";
import { EnvironmentPage } from "@megarax/dev-environment";
import { NotificationDetailsPage, NotificationsPage } from "@megarax/dev-notifications";
import { MegaraxNav } from "@megarax/features";
import { useContext, useEffect, useState } from "react";
import { Outlet, Route } from "react-router-dom-v5-compat";

import { IamAuthContext } from "@megaron/auth-react";

const devTheme: Theme = createTheme("205");

export const useDevRouter = () => {
  return (
    <Route
      path="/dev"
      element={
        <ThemeProvider theme={devTheme}>
          <DevWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="environment" element={<EnvironmentPage />} />
      <Route path="docs/*" element={<DocsPage />} />
      <Route path="notifications/*" element={<NotificationsPage />} />
      <Route path="notifications/uuid/:uuid" element={<NotificationDetailsPage />} />
    </Route>
  );
};

const environmentTemplate = process.env.NX_PUBLIC_ENVIRONMENT_TEMPLATE;

const DevWebappContainer: React.FC = () => {
  const { isLoaded } = useContext(IamAuthContext);

  const { config } = useConfig();
  const { accountsUrl, apiUrl, crmUrl, docsUrl, invoicesUrl, pointsUrl, qrSyncUrl } = config;

  const [isProductionUsed, setIsProductionUsed] = useState<boolean>(false);

  useEffect(() => {
    if (
      apiUrl === API_URL ||
      crmUrl === CRM_URL ||
      docsUrl === DOCS_URL ||
      invoicesUrl === INVOICES_URL ||
      pointsUrl === POINTS_URL ||
      accountsUrl === ACCOUNTS_URL ||
      qrSyncUrl === QR_SYNC_URL
    ) {
      setIsProductionUsed(true);
      return;
    }

    setIsProductionUsed(false);
  }, [accountsUrl, apiUrl, crmUrl, docsUrl, invoicesUrl, pointsUrl, qrSyncUrl]);

  if (!isLoaded) return null;

  return (
    <SiteContainer nav={<MegaraxNav showProductionEnvAlert={isProductionUsed && !environmentTemplate} />}>
      <Outlet />
    </SiteContainer>
  );
};
